module.exports = __webpack_public_path__ + "static/img/qinhuangdao.b5449ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qinhuangdao.jpg
// module id = IAoD
// module chunks = 1